<template>
  <div class="running-text">
    <marquee-text :duration="15" :repeat="10">
      <span class="running-text__item">
        Весь модельный ряд в наличии! Звоните, мы гарантируем выгодное предложение!
      </span>
    </marquee-text>
  </div>
</template>


<script>
import MarqueeText from 'vue-marquee-text-component';

export default {
  name: "running-line",
  components: {
    MarqueeText,
  },
};
</script>


<style lang="scss" scoped>
@import "../styles/constants.scss";

.running-text {
  max-width: 100%;
  font-size: 24px;
  font-weight: bold;
  color: white;
  text-transform: uppercase;
  background-color: $primary;
  padding: 0.5em 0;

  &__item {
    padding: 0 1em;
  }
}

@media (max-width: 640px) {
  .running-text {
    font-size: 16px;
  }
}
</style>
